import gql from "graphql-tag";
import PostFields from "../../fragments/engagement/PostFields";
import PostOrReplyAuthorFields from "../../fragments/engagement/PostOrReplyAuthorFields";
import PostReplyFields from "../../fragments/engagement/PostReplyFields";

export default gql`
  query Posts(
    $contextKey: String
    $contextType: PostContextType!
    $cursor: Cursor
    $limit: Int = 30
    $filterBy: PostFilterBy
    $orderBy: PostOrder
  ) {
    posts(
      contextKey: $contextKey
      contextType: $contextType
      cursor: $cursor
      limit: $limit
      filterBy: $filterBy
      orderBy: $orderBy
    ) @connection(key: "posts", filter: ["contextKey", "contextType", "filterBy", "orderBy"]) {
      nodes {
        ...PostFields

        replies(limit: 8) {
          nodes {
            ...PostReplyFields
          }
          totalCount
          pageInfo {
            cursor
            hasNextPage
          }
        }
        participants(top: 5) {
          nodes {
            ...PostOrReplyAuthorFields
          }
          totalCount
        }
      }
      totalCount
      pageInfo {
        cursor
        hasNextPage
      }
    }
  }

  ${PostFields}
  ${PostReplyFields}
  ${PostOrReplyAuthorFields}
`;
